var _templateObject;
function _taggedTemplateLiteral(e, t) { return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, { raw: { value: Object.freeze(t) } })); }
import React from "react";
import { scrollToTargetAdjusted } from "../../../utils/ui";
import styled from "styled-components";
import BsArrowRightShort from "@meronex/icons/bs/BsArrowRightShort";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
var Butt = styled.button(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  ", "\n  ", "\n"])), function (props) {
  return props.fontFamily && "font-family: ".concat(props.fontFamily, " !important;");
}, function (props) {
  return props.fontSize && "font-size: ".concat(props.fontSize, " !important;");
});
var Button = function Button(props) {
  var _redux$auth$isAuthent, _redux$auth;
  var content = props.content,
    className = props.className,
    link = props.link,
    path = props.path,
    fontFamily = props.fontFamily,
    fontSize = props.fontSize,
    animateEffect = props.animateEffect,
    outlineClassName = props.outlineClassName,
    scrollTo = props.scrollTo,
    _onClick = props.onClick,
    onClickFunc = props.onClickFunc,
    redeemNow = props.redeemNow,
    pdf = props.pdf,
    embeddedReferSection = props.embeddedReferSection,
    embeddedPath = props.embeddedPath,
    disabled = props.disabled,
    _props$config = props.config,
    config = _props$config === void 0 ? {} : _props$config,
    _props$redux = props.redux,
    redux = _props$redux === void 0 ? {} : _props$redux,
    _props$router = props.router,
    router = _props$router === void 0 ? {} : _props$router;
  var history = (router === null || router === void 0 ? void 0 : router.history) || {
    push: function push() {}
  };
  var isAuthenticated = (_redux$auth$isAuthent = redux === null || redux === void 0 || (_redux$auth = redux.auth) === null || _redux$auth === void 0 ? void 0 : _redux$auth.isAuthenticated) !== null && _redux$auth$isAuthent !== void 0 ? _redux$auth$isAuthent : false;
  var location = (router === null || router === void 0 ? void 0 : router.location) || {
    pathname: "",
    search: ""
  };
  var dispatch = redux === null || redux === void 0 ? void 0 : redux.dispatch;
  var authActions = (redux === null || redux === void 0 ? void 0 : redux.authActions) || {};
  var buttonClassName = className || (config === null || config === void 0 ? void 0 : config.clientButtonClassName);
  var changePath = function changePath(path) {
    var _history$push;
    history === null || history === void 0 || (_history$push = history.push) === null || _history$push === void 0 || _history$push.call(history, "".concat(path).concat(pdf ? "?pdf=".concat(pdf) : ""));
  };
  var changePathAndScroll = function changePathAndScroll(path) {
    var _history$push2;
    history === null || history === void 0 || (_history$push2 = history.push) === null || _history$push2 === void 0 || _history$push2.call(history, {
      pathname: path,
      state: {
        scrollTo: scrollTo
      }
    });
  };
  var openLoginModal = function openLoginModal() {
    var _authActions$openLogi;
    dispatch === null || dispatch === void 0 || dispatch(authActions === null || authActions === void 0 || (_authActions$openLogi = authActions.openLoginModal) === null || _authActions$openLogi === void 0 ? void 0 : _authActions$openLogi.call(authActions));
  };
  var onClickHandler = function onClickHandler(e, type) {
    var _authActions$openLogi2;
    switch (type) {
      case "SCROLL":
        return scrollToTargetAdjusted(scrollTo);
      case "LINK":
        return window.open(link);
      case "FUNC":
        return onClickFunc(e);
      case "CHANGE_PATH":
        return changePath(path);
      case "CHANGE_PATH_AND_SCROLL":
        return changePathAndScroll(path);
      case "LOGIN_AND_CHANGE_PATH":
        return isAuthenticated ? changePath(path) : (changePath("".concat(location.pathname, "?postLoginUrl=").concat(path)), openLoginModal());
      case "OPEN_LOGIN":
        return dispatch === null || dispatch === void 0 ? void 0 : dispatch(authActions === null || authActions === void 0 || (_authActions$openLogi2 = authActions.openLoginModal) === null || _authActions$openLogi2 === void 0 ? void 0 : _authActions$openLogi2.call(authActions));
      default:
        return;
    }
  };
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [!animateEffect && /*#__PURE__*/_jsx(Butt, {
      onClick: function onClick(e) {
        return onClickHandler(e, _onClick);
      },
      className: "\n                ".concat(buttonClassName ? buttonClassName : " py-2 px-10 rounded-none bg-primary font-brandFont text-primary hover:bg-primary-focus", " ").concat(redeemNow ? redeemNow : "", " disabled:bg-gray-300 disabled:cursor-not-allowed disabled:hover:bg-gray-300 disabled:text-white disabled:hover:text-white disabled:hover:border-none disabled:border-none\n           "),
      fontFamily: fontFamily,
      fontSize: fontSize,
      disabled: !!disabled,
      children: content
    }), animateEffect && /*#__PURE__*/_jsxs("div", {
      onClick: function onClick(e) {
        return onClickHandler(e, _onClick);
      },
      className: "relative cursor-pointer group mt-8 ",
      children: [/*#__PURE__*/_jsxs("button", {
        className: "relative  z-20 hoh_gradient_btn  ".concat(buttonClassName ? buttonClassName : "px-10 py-2 text-md border-[1.5px] border-accent-focus text-accent-focus hover:text-white ", " "),
        children: [content, " ", /*#__PURE__*/_jsx(BsArrowRightShort, {
          className: "invisible group-hover:visible inline absolute text-2xl right-4 group-hover:right-1.5  transition ease-in-out duration-700 top-2 text-white"
        })]
      }), /*#__PURE__*/_jsx("div", {
        className: "absolute top-1 -right-1 w-full h-full border-[1.5px] z-10  ".concat(outlineClassName ? outlineClassName : "border-accent-focus group-hover:border-primary", "  pointer-events-none\n                    ")
      })]
    })]
  });
};
export default Button;